module.exports = __webpack_public_path__ + "static/media/22.9dc1a209.jpg";